/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CrearProgramaModelDto } from '../../models/crear-programa-model-dto';

export interface ProgramasControllerActualizarPrograma$Params {
  uuidPrograma: string;
  
    /**
     * Datos del programa a actualizar
     */
    body: CrearProgramaModelDto
}

export function programasControllerActualizarPrograma(http: HttpClient, rootUrl: string, params: ProgramasControllerActualizarPrograma$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, programasControllerActualizarPrograma.PATH, 'put');
  if (params) {
    rb.path('uuidPrograma', params.uuidPrograma, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

programasControllerActualizarPrograma.PATH = '/api/programas/actualizar-programa/{uuidPrograma}';
